import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailAddress",
  class: "form-label"
}, "Email Address", -1)
const _hoisted_4 = ["readonly"]
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First Name", -1)
const _hoisted_8 = ["readonly"]
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last Name", -1)
const _hoisted_12 = ["readonly"]
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Update Employee ")

import { Ref, ref, watch } from "vue";
import { getFunctions } from "firebase/functions";
import ModalView from "@/components/ModalView.vue";
import { ValidationType } from "@/model/organisation";
import { ApiService } from "@/api-service";
import { Employee } from "@/model/employee";


export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean },
    validationType: null,
    organisationId: null,
    employee: null
  },
  emits: ["hide-modal"],
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  validationType: ValidationType;
  organisationId: string;
  employee: Employee;
}



let firstName: Ref<string | null> = ref(null);
let firstNameError: Ref<string | null> = ref(null);

let lastName: Ref<string | null> = ref(null);
let lastNameError: Ref<string | null> = ref(null);

let emailAddress: Ref<string | null> = ref(null);
let emailAddressError: Ref<string | null> = ref(null);

let loading: Ref<boolean> = ref(false);



const apiService = new ApiService(getFunctions());

async function editEmployee() {
  loading.value = true;
  await apiService
    .editEmployees(props.organisationId, [
      {
        employeeId: props.employee.id,
        firstName: firstName.value,
        lastName: lastName.value,
        emailAddress: emailAddress.value,
      },
    ])
    .then(() => {
      emit("hide-modal");
    })
    .catch((error) => {
      console.log("Failed to edit employees", error);
    });
  loading.value = false;
}

watch(
  () => props.isVisible,
  (visible: boolean) => {
    if (visible) {
      firstName.value = props.employee.firstName;
      firstNameError.value = null;
      lastName.value = props.employee.lastName;
      lastNameError.value = null;

      if (props.validationType == ValidationType.email) {
        emailAddress.value = props.employee.id;
      } else {
        emailAddress.value = props.employee.emailAddress;
      }
      emailAddressError.value = null;
    }
  }
);

watch(
  () => emailAddress.value,
  () => {
    emailAddressError.value = null;
  }
);
watch(
  () => firstName.value,
  () => {
    firstNameError.value = null;
  }
);
watch(
  () => lastName.value,
  () => {
    lastNameError.value = null;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalView, {
    "is-visible": __props.isVisible,
    onHideModal: _cache[4] || (_cache[4] = ($event: any) => (emit('hide-modal')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn-close", { disabled: _unref(loading) }]),
        "data-bs-dismiss": "modal",
        "aria-label": "Close"
      }, null, 2)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(emailAddressError) }]),
            id: "emailAddress",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emailAddress) ? (emailAddress).value = $event : emailAddress = $event)),
            readonly: _unref(loading) || __props.validationType === _unref(ValidationType).email
          }, null, 10, _hoisted_4), [
            [_vModelText, _unref(emailAddress)]
          ]),
          (_unref(emailAddressError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(emailAddressError)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(firstNameError) }]),
            id: "firstName",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(firstName) ? (firstName).value = $event : firstName = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_8), [
            [_vModelText, _unref(firstName)]
          ]),
          (_unref(firstNameError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(firstNameError)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(lastNameError) }]),
            id: "lastName",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(lastName) ? (lastName).value = $event : lastName = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_12), [
            [_vModelText, _unref(lastName)]
          ]),
          (_unref(lastNameError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(lastNameError)), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-primary", { disabled: _unref(loading) }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (editEmployee()))
      }, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_14))
          : _createCommentVNode("", true),
        _hoisted_15
      ], 2)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})